import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiListModule } from "@snelstart/ui-list";
import { SharedUiLoadingModule } from "@snelstart/ui-loading";
import { SharedUiOffCanvasModule } from "@snelstart/ui-off-canvas";
import { FeatureTaxDividendDetailsComponent } from "./tax-dividend-details/feature-tax-dividend-details.component";
import {InhoudingsplichtigeComponent} from "./dividend/inhoudingsplichtige/inhoudingsplichtige.component";
import {ContactgegevensComponent} from "./dividend/contactgegevens/contactgegevens.component";
import {InhoudingsvrijstellingComponent} from "./dividend/inhoudingsvrijstelling/inhoudingsvrijstelling.component";
import {NormaaltariefComponent} from "./dividend/normaaltarief/normaaltarief.component";
import {VerdragstariefComponent} from "./dividend/verdragstarief/verdragstarief.component";
import {AlgemeenComponent} from "./dividend/algemeen/algemeen.component";
import {OverzichtComponent} from "./dividend/overzicht/overzicht.component";
import {OpgaafComponent} from "./dividend/opgaaf/opgaaf.component";
import {VoorkomingComponent} from "./dividend/voorkoming/voorkoming.component";
import {BijzonderhedenComponent} from "./dividend/bijzonderheden/bijzonderheden.component";
import {
    TekstInhoudingsplichtigeComponent
} from "./dividend/toelichtingen-tekst/tekst-inhoudingsplichtige/tekst-inhoudingsplichtige.component";
import {
    TekstContactgegevensComponent
} from "./dividend/toelichtingen-tekst/tekst-contactgegevens/tekst-contactgegevens.component";
import {
    TekstDividendbelastingComponent
} from "./dividend/toelichtingen-tekst/tekst-dividendbelasting/tekst-dividendbelasting.component";
import {
    TekstMetInhoudingDividendbelastingComponent
} from "./dividend/toelichtingen-tekst/tekst-met-inhouding-dividendbelasting/tekst-met-inhouding-dividendbelasting.component";
import {
    TekstMetInhoudingsvrijstellingComponent
} from "./dividend/toelichtingen-tekst/tekst-met-inhoudingsvrijstelling/tekst-met-inhoudingsvrijstelling.component";
import {
    TekstOverigeVragenComponent
} from "./dividend/toelichtingen-tekst/tekst-overige-vragen/tekst-overige-vragen.component";
import {
    TekstVragenVoorafComponent
} from "./dividend/toelichtingen-tekst/tekst-vragen-vooraf/tekst-vragen-vooraf.component";
import {
    TekstMetInhoudingDividendbelastingBuitenlandComponent
} from "./dividend/toelichtingen-tekst/tekst-met-inhouding-dividendbelasting-buitenland/tekst-met-inhouding-dividendbelasting-buitenland.component";
import {
    TekstMetInhoudingsvrijstellingBuitenlandComponent
} from "./dividend/toelichtingen-tekst/tekst-met-inhoudingsvrijstelling-buitenland/tekst-met-inhoudingsvrijstelling-buitenland.component";


@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    InhoudingsplichtigeComponent,
    OverzichtComponent,
    OpgaafComponent,
    VoorkomingComponent,
    BijzonderhedenComponent,
    ContactgegevensComponent,
    InhoudingsvrijstellingComponent,
    NormaaltariefComponent,
    VerdragstariefComponent,
    AlgemeenComponent,
    TekstInhoudingsplichtigeComponent,
    TekstContactgegevensComponent,
    TekstDividendbelastingComponent,
    TekstMetInhoudingDividendbelastingComponent,
    TekstMetInhoudingsvrijstellingComponent,
    TekstOverigeVragenComponent,
    TekstVragenVoorafComponent,
    TekstMetInhoudingDividendbelastingBuitenlandComponent,
    TekstMetInhoudingsvrijstellingBuitenlandComponent,
    FeatureTaxDividendDetailsComponent
  ],
  declarations: [
  ],
  exports: [FeatureTaxDividendDetailsComponent],
})
export class FeatureTaxDividendDetailsModule {}
